// TODO: import to this file is deprecated!
import BlockQuoteItem from "../../../BlockQuote";
import BlockQuoteThumb from "../../../BlockQuote/Thumb";

export { default } from "../../../BlockQuote/Slider";

export { BlockQuoteItem, BlockQuoteThumb };
